import React from "react";

import {
  Box,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
} from "@chakra-ui/react";
import { ReactComponent as BulletGreyIcon } from "assets/icons/bullet-grey.svg";
import { ReactComponent as GreenCheckIcon } from "assets/icons/green-check-circle.svg";
import { ReactComponent as RedCloseIcon } from "assets/icons/red-close-cricle.svg";
import { ReactComponent as RedInfoOutlineIcon } from "assets/icons/red-info-outline.svg";
import { businessSectionTypeToLabelMap } from "hooks/useApproveOrRejectBusinessSection";
import { formatDateToDDMMTTSS } from "utils";

import { Paragraph3, Paragraph4 } from "ui/typography";

import { IComplianceTrailTimelineItemProps } from "./types";

const START_INDEX = 0;

export const ComplianceTrailTimelineItem = (
  props: IComplianceTrailTimelineItemProps
) => {
  const {
    complianceTrail,
    isFirstComplianceTrailItem,
    isLastComplianceTrailItem,
  } = props;

  const getIconWrapperClassName = (): string => {
    if (complianceTrail.sectionStatus === "approved") {
      return "top-[10px]";
    } else if (isFirstComplianceTrailItem) {
      return "pt-[9px] top-3 bg-white";
    }
    return "top-[17px] bg-white";
  };

  return (
    <TimelineItem css={{ display: "flex", gap: "7px" }}>
      <TimelineConnector>
        <Box
          position="relative"
          h="100%"
          className="w-6"
        >
          {!isLastComplianceTrailItem && (
            <Box
              w="1.5px"
              h="100%"
              position="absolute"
              top="0"
              left="calc(50% - 1px)"
              zIndex={0}
              className="bg-[#D1D5DB]"
            />
          )}
          <Box
            position="absolute"
            className={getIconWrapperClassName()}
            left="50%"
            transform="translate(-50%, -50%)"
            zIndex={1}
          >
            {complianceTrail.sectionStatus === "approved" ? (
              <GreenCheckIcon />
            ) : (
              <RedCloseIcon />
            )}
          </Box>
        </Box>
      </TimelineConnector>
      <TimelineContent css={{ paddingBottom: "34px" }}>
        <Box className="h-[95px] flex flex-col gap-4">
          <Box className="h-[39px] flex flex-col gap-[2px]">
            <Box className="flex gap-1 items-center">
              <Paragraph3
                textColor="#101828"
                fontWeight="500"
              >
                {
                  businessSectionTypeToLabelMap[
                    complianceTrail.complianceSection
                  ]
                }
              </Paragraph3>
              <BulletGreyIcon />
              <Paragraph3
                textColor="#101828"
                fontWeight="500"
                className="capitalize"
              >
                {complianceTrail.sectionStatus}
              </Paragraph3>
            </Box>
            <Paragraph4
              textColor="#667085"
              lineHeight="21px"
            >
              {formatDateToDDMMTTSS(complianceTrail.createdAt)}
            </Paragraph4>
          </Box>
          <Box className="h-10 flex gap-[6px]">
            <Box
              className="w-8 h-8 rounded-[50%] text-[12.8px] leading-[19.2px] text-center text-white flex justify-center items-center"
              css={{
                backgroundColor: complianceTrail.bgColor,
              }}
            >
              {complianceTrail.adminName.charAt(START_INDEX)}
            </Box>
            <Box>
              <Paragraph3
                textColor="#101828"
                fontWeight="500"
                lineHeight="15.96px"
              >
                {complianceTrail.adminName}
              </Paragraph3>
              <Paragraph4
                textColor="#667085"
                lineHeight="21px"
              >
                {complianceTrail.adminEmail}
              </Paragraph4>
            </Box>
          </Box>
        </Box>
        {complianceTrail.sectionStatus === "rejected" && (
          <Box className="bg-[#FEF2F2] border-[#FFC5C5] border-[0.5px] py-3 px-[14px] rounded-xl flex items-center gap-[9px]">
            <RedInfoOutlineIcon className="shrink-0" />
            <Box className="flex flex-col gap-1">
              <Paragraph3
                textColor="#1D1D1D"
                fontWeight="500"
                lineHeight="15.96px"
              >
                Reason for Rejection
              </Paragraph3>
              <Paragraph3
                textColor="#1D1D1D"
                fontSize="13px"
                lineHeight="20px"
              >
                {complianceTrail.reason}
              </Paragraph3>
            </Box>
          </Box>
        )}
      </TimelineContent>
    </TimelineItem>
  );
};
